var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "flex w-full rounded overflow-hidden gap-3",
      class: _vm.parentClass,
      style: { "--radio-color": _vm.color, "--radio-border": _vm.bColor },
      attrs: { id: "checkBoxes_container" },
    },
    _vm._l(_vm.options, function (option) {
      return _c(
        "div",
        {
          key: option.value,
          staticClass: "radio-container flex items-center gap-2",
        },
        [
          _c("input", {
            staticClass: "inp-cbx customRadio",
            attrs: { name: _vm.name, type: _vm.type, id: option.value },
            domProps: {
              value: option.value,
              checked: _vm.value == option.value,
            },
            on: { change: _vm.handleChange },
          }),
          _c("label", { attrs: { for: option.value } }, [
            _c("span", { staticClass: "custom_check" }),
            _vm._v(" " + _vm._s(option.label)),
          ]),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }